import './index.css'
import React from 'react'
import Delta from 'components/ui/delta'
type Props = {
  caption?: React.ReactNode
  delta?: number
  smallValueFont?: boolean
  value: React.ReactNode
}

/**
 * A counter display component with optional delta indicator and customizable value font size
 * @param caption - Optional caption text to display above the counter value
 * @param delta - Optional percentage change value to display as delta indicator
 * @param value - The main counter value to display
 * @param smallValueFont - Whether to use smaller font size for the value - defaults to false
 * @returns A div element containing the counter with caption, value, and optional delta
 */
const Counter = ({ caption, delta, value, smallValueFont }: Props) => (
  <div className="Counter">
    {caption && <div className="Counter-caption">{caption}</div>}
    <div className="Counter-data">
      <div className={smallValueFont ? 'Counter-small-value' : 'Counter-value'}>
        {value}
      </div>
      {delta && delta !== 0 && (
        <div className="Counter-delta">
          <Delta
            type={delta > 0 ? 'positive' : 'negative'}
            value={`${Math.abs(delta)}%`}
          />
        </div>
      )}
    </div>
  </div>
)

export default React.memo<Props>(Counter)
